import { MenuItem, Stack, TextField } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import type { ButtonBlockContent } from '@/types/database';

// These options are literally MUI Button's own `variant`/`color` props —
// this panel configures a real Button, not a translated vocabulary.
const VARIANT_OPTIONS: ButtonBlockContent['variant'][] = ['contained', 'outlined', 'text'];
const COLOR_OPTIONS: ButtonBlockContent['color'][] = ['primary', 'secondary', 'inherit'];

export function ButtonBlockEditPanel({
  content,
  onUpdate,
}: {
  content: ButtonBlockContent;
  onUpdate: (content: ButtonBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content || { text: '', link: '' }, onUpdate);

  return (
    <Stack spacing={1.5}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <TextField
          label="Button Text"
          value={draft.text || ''}
          onChange={(event) => update({ ...draft, text: event.target.value })}
          fullWidth
        />
        <TextField
          label="Link"
          value={draft.link || ''}
          onChange={(event) => update({ ...draft, link: event.target.value })}
          fullWidth
        />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <TextField
          select
          label="Variant"
          value={draft.variant ?? 'contained'}
          onChange={(event) => update({ ...draft, variant: event.target.value as ButtonBlockContent['variant'] }, { immediate: true })}
          fullWidth
        >
          {VARIANT_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
        <TextField
          select
          label="Color"
          value={draft.color ?? 'primary'}
          onChange={(event) => update({ ...draft, color: event.target.value as ButtonBlockContent['color'] }, { immediate: true })}
          fullWidth
        >
          {COLOR_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
      </Stack>
    </Stack>
  );
}
